import { useEffect } from 'react';

const useScriptInHead = (resourceUrl, onload) => {
  useEffect(() => {
    if (!resourceUrl) return;

    const script = document.createElement('script');
    script.src = resourceUrl;
    script.async = true;
    document.body.appendChild(script);

    script.onload = function () {
      onload();
    }

    return () => {
      document.body.removeChild(script);
    };
  }, [resourceUrl]);
};

export default useScriptInHead;